/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiQuerySessionDto } from '../../models/ai-query-session-dto';

export interface AiSessionsPost$Plain$Params {
}

export function aiSessionsPost$Plain(http: HttpClient, rootUrl: string, params?: AiSessionsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQuerySessionDto>> {
  const rb = new RequestBuilder(rootUrl, aiSessionsPost$Plain.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiQuerySessionDto>;
    })
  );
}

aiSessionsPost$Plain.PATH = '/ai/sessions';
